/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable max-len */
import { useState, useEffect } from 'react';

import Head from 'next/head';
import { useRouter } from 'next/router';
import { Link as Slink } from 'react-scroll';
import Slider from 'react-slick';
import { Modal, ModalBody, Container } from 'reactstrap';

import Collapse from '../../components/includes/collapse';
import DentistForm from '../../components/includes/dentist-form';
import ProcessCard from '../../components/includes/process-card';
import Layout from '../../components/layout/layout';
import { buttonClickEvent, videoPlayedEvent } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap, countryMap } from '../../language.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';
import { dentistPageSlides, sliderSettingsDentistPage1, sliderSettingsDentistPage2 } from '../../utils/slider.config';

import '../../styles/dentists.scss';

const Dentist = () => {
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const dentistPage = i18n.t('dentist_page');
  const faqData = Object.values(i18n.t('faqs'));
  const router = useRouter();
  const { id } = router.query;
  const [selectedTab, setSelectedTab] = useState('app');
  const tabs = {
    app: 'Zenyum App',
    production: 'Production Technology',
    customer_care: 'World Class Customer Care in 7 Countries'
  };
  const [modal1, setModal1] = useState(false);
  const toggle1 = () => {
    setModal1(!modal1);
    setTimeout(() => {
      if (modal1) videoPlayedEvent('dentist', countryMap[country]);
    }, 100);
  };
  const [modal2, setModal2] = useState(false);
  const toggle2 = () => {
    setModal2(!modal2);
    setTimeout(() => {
      if (modal2) videoPlayedEvent('dentist', countryMap[country]);
    }, 100);
  };
  const [modal3, setModal3] = useState(false);
  const toggle3 = () => {
    setModal3(!modal3);
    setTimeout(() => {
      if (modal3) videoPlayedEvent('dentist', countryMap[country]);
    }, 100);
  };
  const pageMetaData = i18n.t('metadata').dentistPage;

  // const [isMobile, setIsMobile] = useState(false);
  const [isPortrait, setisPortrait] = useState(false);

  const processCards = Object.values(i18n.t('dentist_page.why_partner.process_cards'));
  const cardImages = ['dentist/whypartner-icon1.svg', 'dentist/whypartner-icon2.svg', 'dentist/whypartner-icon3.svg', 'dentist/whypartner-icon4.svg'];

  useEffect(() => {
    // setIsMobile(window.innerWidth < 1024);
    setisPortrait(window.innerWidth < 768);
    if (Object.keys(tabs).includes(id)) setSelectedTab(id);
    window.addEventListener('resize', () => {
      setisPortrait(window.innerWidth < 768);
    });
  }, []);

  const setTab = (tab) => {
    setSelectedTab(tab);
    buttonClickEvent(
      tab,
      tabs[tab],
      'webpage',
      'Dentists',
      'Zenyum Invisible Braces Case Study',
      countryMap[country]
    );
  };

  return (
    <Layout
      page="for_dentists"
      title={pageMetaData.title}
      description={pageMetaData.description}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'For Dentists', properties: { } }}
      pageUrl="dentist"
      pageEnabledMarkets={[]}
    >
      <Head>
        <meta
          httpEquiv="content-language"
          content={contentLanguageMap[i18n.activeLocale]}
        />
        <link rel="stylesheet" href="/vendor/slick/slick.min.css" />
        <link rel="stylesheet" href="/vendor/slick/slick-theme.min.css" defer={true} />
      </Head>
      <section className="dentist-banner">
        <div className="dentist-banner__img" data-bg={`/img/dentist/dentist-banner${isPortrait ? '_mobile' : ''}.jpg`} data-gmlazy="false" />
        <Container>
          <div className="dentist-banner__text">
            <h1
              data-key="dentist_page::banner::title"
              data-lokalise=""
            >
              {dentistPage.banner.title}
            </h1>
            <Slink to="partner-form" spy={true} smooth={true} offset={-150} duration={500}>
              <a
                href="#"
                className="web-btn"
                data-key="dentist_page::banner::link"
                data-lokalise=""
                onClick={() => buttonClickEvent('dentist-btn-1', 'Be a Zenyum partner',
                  'webpage', 'Dentists', 'partner form', countryMap[country])}
              >
                {dentistPage.banner.link}
              </a>
            </Slink>
          </div>
        </Container>
        <a
          className="scrollDown"
        >
          <span
            data-key="dentist_page::banner::scroll"
            data-lokalise=""
          >
            {dentistPage.banner.scroll}
          </span>
          <img src="/img/icon_arrow.svg" alt="arrow icon" />
        </a>
      </section>
      {/* <section className="dentist-video" style={{ backgroundImage: `url('../img/dentist/dentist-video${isPortrait ? '_mobile' : ''}.jpg')` }}> */}
      {/* <section className="dentist-video" style={{ backgroundImage: `url(${gumletLoader({ src: `/img/dentist/dentist-video${isPortrait ? '_mobile' : ''}.jpg`, width: isPortrait ? 768 : 1920 })})` }}> */}
      <section className="dentist-video" data-bg={`/img/dentist/dentist-video${isPortrait ? '_mobile' : ''}.jpg`}>
        <a className="dentist-video__btn" onClick={toggle1} aria-hidden="true">
          <span />
        </a>
        <Modal
          isOpen={modal1}
          toggle={toggle1}
          className="video-popup"
        >
          <a className="close" onClick={toggle1} aria-hidden="true"><img src="/img/close-bold.svg" alt="Close popup" /></a>
          <ModalBody className="iframe-video">
            <iframe src="https://www.youtube.com/embed/JP4J5sH3alE?rel=0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} />
          </ModalBody>
        </Modal>
      </section>
      <section className="how-it-works dentist-partner" id="how-it-works">
        <Container>
          <h2
            data-key="dentist_page::banner::scroll"
            data-lokalise=""
          >
            {dentistPage.why_partner.title}
          </h2>
          <div className="carouselWrapper">
            <Slider {...sliderSettingsDentistPage1}>
              {processCards && processCards.length > 0 && processCards.map((row, index) => (
                <div className="slide-wrapper">
                  <ProcessCard
                    image={cardImages[index]}
                    content={row.content}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </Container>
      </section>
      {country === 'tw' && (
        <section className="dentist-patientflow">
          <img className="img-fluid" data-gumlet="false" src={`/img/dentist/patient_flow_new_${isPortrait ? 'mobile' : 'desktop'}.png`} alt="Dentist - Patient flow" />
        </section>
      )}
      <section className="dentist-casestudy">
        <Container>
          <h2
            data-key="dentist_page::case_study::title"
            data-lokalise=""
          >
            {dentistPage.case_study.title}
          </h2>
          <div className="casestudy-container">
            <div className="casestudy-container__htab" />
            <div className="casestudy-container__vtab">
              <div className="vtab-links">
                <h2
                  className={`dentist-vtabs ${selectedTab === 'app' && 'selected-tab'}`}
                  onClick={() => setTab('app')}
                  role="presentation"
                  data-key="dentist_page::case_study::tab_headings::heading_1"
                  data-lokalise=""
                >
                  {dentistPage.case_study.tab_headings.heading_1}
                </h2>
                <h2
                  className={`dentist-vtabs ${selectedTab === 'production' && 'selected-tab'}`}
                  onClick={() => setTab('production')}
                  role="presentation"
                  data-key="dentist_page::case_study::tab_headings::heading_2"
                  data-lokalise=""
                >
                  {dentistPage.case_study.tab_headings.heading_2}
                </h2>
                <h2
                  className={`dentist-vtabs ${selectedTab === 'customer_care' && 'selected-tab'}`}
                  onClick={() => setTab('customer_care')}
                  role="presentation"
                  data-key="dentist_page::case_study::tab_headings::heading_3"
                  data-lokalise=""
                >
                  {dentistPage.case_study.tab_headings.heading_3}
                </h2>
              </div>
              <div className="vtab-content">
                <div style={{ display: selectedTab === 'app' ? 'block' : 'none' }}>
                  <div className="vtab-content__media">
                    {/* <img src="/img/dentist/dentist-tabimg.png" alt="Zenyum App" /> */}
                    {/* <img src={gumletLoader({ src: `/img/dentist/dentist-tabimg.png`, width: 650 })} alt="Zenyum | App" /> */}
                    <img src="/img/dentist/dentist-tabimg-new.png" data-gumlet="false" alt="Zenyum | App" />
                  </div>
                  <div className="list-content">
                    <h3
                      data-key="dentist_page::case_study::tab_content_1::list_title"
                      data-lokalise=""
                    >
                      {dentistPage.case_study.tab_content_1.list_title}
                    </h3>
                    <p
                      data-key="dentist_page::case_study::tab_content_1::list_intro"
                      data-lokalise=""
                    >
                      {dentistPage.case_study.tab_content_1.list_intro}
                    </p>
                    <ul>
                      <li>
                        <p
                          data-key="dentist_page::case_study::tab_content_1::list_content_1"
                          data-lokalise=""
                        >
                          {dentistPage.case_study.tab_content_1.list_content_1}
                        </p>
                      </li>
                      <li>
                        <p
                          data-key="dentist_page::case_study::tab_content_1::list_content_2"
                          data-lokalise=""
                        >
                          {dentistPage.case_study.tab_content_1.list_content_2}
                        </p>
                      </li>
                      <li>
                        <p
                          data-key="dentist_page::case_study::tab_content_1::list_content_3"
                          data-lokalise=""
                        >
                          {dentistPage.case_study.tab_content_1.list_content_3}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div style={{ display: selectedTab === 'production' ? 'block' : 'none' }}>
                  <div className="vtab-content__media video" onClick={toggle2} aria-hidden="true">
                    {/* <img src={`/img/dentist/dentist-tabvideo1${isPortrait ? '_mobile' : ''}.jpg`} alt="Production Technology" /> */}
                    {/* <img src={gumletLoader({ src: `/img/dentist/dentist-tabvideo1${isPortrait ? '_mobile' : ''}.jpg`, width: 650 })} alt="Zenyum | Production Technology" /> */}
                    <img data-src={`/img/dentist/dentist-tabvideo1${isPortrait ? '_mobile' : ''}.jpg`} alt="Zenyum | Production Technology" />
                  </div>
                  <p
                    data-key="dentist_page::case_study::tab_content_2"
                    data-lokalise=""
                  >
                    {dentistPage.case_study.tab_content_2}
                  </p>
                  <Modal
                    isOpen={modal2}
                    toggle={toggle2}
                    className="video-popup"
                  >
                    <a className="close" onClick={toggle2} aria-hidden="true"><img src="/img/close-bold.svg" alt="Close popup" /></a>
                    <ModalBody className="iframe-video">
                      <iframe src="https://www.youtube.com/embed/TbZmNy2ehU8?rel=0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} />
                    </ModalBody>
                  </Modal>
                </div>
                <div style={{ display: selectedTab === 'customer_care' ? 'block' : 'none' }}>
                  <div className="vtab-content__media video" onClick={toggle3} aria-hidden="true">
                    {/* <img src={`/img/dentist/dentist-tabvideo2${isPortrait ? '_mobile' : ''}.jpg`} alt="World Class Customer Care in 7 Countries" /> */}
                    {/* <img src={gumletLoader({ src: `/img/dentist/dentist-tabvideo2${isPortrait ? '_mobile' : ''}.jpg`, width: 650 })} alt="Zenyum | World Class Customer Care in 7 Countries" /> */}
                    <img data-src={`/img/dentist/dentist-tabvideo2${isPortrait ? '_mobile' : ''}.jpg`} alt="Zenyum | World Class Customer Care in 7 Countries" />
                  </div>
                  <p
                    data-key="dentist_page::case_study::tab_content_3"
                    data-lokalise=""
                  >
                    {dentistPage.case_study.tab_content_3.replace('<br/>', '')}
                  </p>
                  <Modal
                    isOpen={modal3}
                    toggle={toggle3}
                    className="video-popup"
                  >
                    <a className="close" onClick={toggle3} aria-hidden="true"><img src="/img/close-bold.svg" alt="Close popup" /></a>
                    <ModalBody className="iframe-video">
                      <iframe src="https://www.youtube.com/embed/x0HWpevkAJA?rel=0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} />
                    </ModalBody>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="as-seen-on">
        <Container>
          <h2
            data-key="dentist_page::logo_slider_title"
            data-lokalise=""
          >
            {dentistPage.logo_slider_title}
          </h2>
          <div className="carouselWrapper">
            <Slider {...sliderSettingsDentistPage2}>
              {dentistPageSlides && dentistPageSlides.length > 0 && dentistPageSlides.map((row) => (
                <div className="slide-wrapper">
                  <img src={`/img/slides/${row}`} alt="slider" />
                </div>
              ))}
            </Slider>
          </div>
        </Container>
      </section>
      {/* <section className="dentist-location" style={{ backgroundImage: `url('../img/dentist/dentist-map${isPortrait ? '_mobile' : ''}.png')` }}> */}
      {country !== 'jp' && (
        <section
          className={`dentist-location ${country === 'jp' ? 'no-bgmap' : 'bgmap'}`}
          data-bg={`/img/dentist/dentist-map${isPortrait ? '_mobile' : ''}.png`}
        >
          <Container>
            <div className="location-container">
              <h2
                data-key="dentist_page::location_map::title"
                data-lokalise=""
              >
                {dentistPage.location_map.title}
              </h2>
              <div>
                <h3
                  data-key="dentist_page::location_map::sub_heading_1"
                  data-lokalise=""
                >
                  {dentistPage.location_map.sub_heading_1}
                </h3>
                <p
                  data-key="dentist_page::location_map::content_1"
                  data-lokalise=""
                >
                  {dentistPage.location_map.content_1}
                </p>
              </div>
              <div>
                <h3
                  data-key="dentist_page::location_map::sub_heading_2"
                  data-lokalise=""
                >
                  {dentistPage.location_map.sub_heading_2}
                </h3>
                <p
                  data-key="dentist_page::location_map::content_2"
                  data-lokalise=""
                >
                  {dentistPage.location_map.content_2}
                </p>
              </div>
              <div>
                <h3
                  data-key="dentist_page::location_map::sub_heading_3"
                  data-lokalise=""
                >
                  {dentistPage.location_map.sub_heading_3}
                </h3>
                <p
                  data-key="dentist_page::location_map::content_3"
                  data-lokalise=""
                >
                  {dentistPage.location_map.content_3}
                </p>
              </div>
              <Slink to="partner-form" spy={true} smooth={true} offset={-150} duration={500}>
                <a
                  href="#"
                  className="web-btn"
                  data-key="dentist_page::location_map::link"
                  data-lokalise=""
                  onClick={() => buttonClickEvent('dentist-btn-2', 'Be a Zenyum partner',
                    'webpage', 'Dentists', 'partner form', countryMap[country])}
                >
                  {dentistPage.location_map.link}
                </a>
              </Slink>
            </div>
          </Container>
        </section>
      )}
      <section className="dentist-form-section" id="partner-form">
        <Container>
          <DentistForm />
        </Container>
      </section>
      <section className="dentist-faq">
        <Container>
          <div className="faq-wrapper">
            <div className="sections-wrapper">
              <h2
                data-key="dentist_page::faq_title"
                data-lokalise=""
              >
                {dentistPage.faq_title}
              </h2>
              <section className="faq-section">
                <div className="">
                  {faqData[2].data && faqData[2].data.length > 0 && faqData[2].data.map((row) => (
                    row.question && row.question !== 'nil' && (
                    <div className="faq-collapse-wrapper">
                      <Collapse title={row.question} content={row.answer} topic="For Partners" />
                    </div>
                    )
                  ))}
                </div>
              </section>
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.DENTIST;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default Dentist;
